import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';
import { AppService } from '@services/Logic/app.service';
import {
  AuthGuard,
  PreventLoginGuard,
  AuthSuccessGuardRedirect,
} from '@services/Logic/auth.guard';
import { AuthService } from '@services/http/auth.service';
import { AiPriceBudgetSuggesterService } from '@services/http/aiPriceBudgetSuggester.service';
import { BrowsingDatapointsService } from '@services/http/browsingDatapoints.service';
import { BrowserPushNotificationService } from '@services/Logic/browser-push-notification.service';
import { EventService } from '@services/Logic/Event.service';
import { CategoryTipsSuggestionDescService } from '@services/Logic/category-tips-suggestion-desc-service';
import { CommentService } from '@services/http/comment.service';
import { CompanyService } from '@services/http/company.service';
import { ConfettiService } from '@services/Logic/confettiService';
import { ConflictCaseService } from '@services/http/conflictCase.service';
import { ConversationService } from '@services/http/conversation.service';
import { CityService } from '@services/http/city.service';
import { DataEnrichmentService } from '@services/http/dataEnrichment.service';
import { DueDateNegotiationService } from '@services/http/dueDateNegotiation.service';
import { InterceptorService } from '@services/Logic/interceptor.service';
import { FaqService } from '@services/http/faq.service';
import { HistoryChangesService } from '@services/Logic/historyChanges.service';
import { HowToService } from '@services/http/howTo.service';
import { LocationService } from '@services/http/location.service';
import { MediaService } from '@services/http/media.service';
import { MessageService } from '@services/http/message.service';
import { MiscService } from '@services/http/misc.service';
import { NotificationService } from '@services/http/notification.service';
import { NotificationSettingsService } from '@services/http/notificationSettings.service';
import { NavigationService } from '@services/Logic/navigation.service';
import { OfferService } from '@services/http/offer.service';
import { OfferCommentService } from '@services/http/offerComment.service';
import { OfferRequestService } from '@services/http/offerRequest.service';
import { PaymentService } from '@services/http/payment.service';
import { PriceGuideService } from '@services/http/priceGuide.service';
import { PaymentHelperService } from '@services/Logic/paymentHelper.service';
import { ReportService } from '@services/http/report.service';
import { ReviewService } from '@services/http/review.service';
import { ReferralService } from '@services/http/referral.service';
import { RandomImageService } from '@services/Logic/randomImg.service';
import { SociallogService } from '@services/http/sociallog.service';
import { StateService } from '@services/Logic/state.service';
import { StorageService } from '@services/Logic/storage.service';
import { RegionService } from '@services/http/region.service';
import { RehireRequestService } from '@services/http/rehireRequest.service';
import { TimeHelperService } from '@services/Logic/timeHelper.service';
import { TranslateService } from '@services/Logic/translate.service';
import { SocketService } from '@services/http/socket.service';
import { TagService } from '@services/http/tag.service';
import { TaskService } from '@services/http/task.service';
import { SupportService } from '@services/http/support.service';
import { StaticDataService } from '@services/Logic/static-data-service';
import { StoredCreditService } from '@services/http/storedCredit.service';
import { TierPauseService } from '@services/http/tierPause.service';
import { UserService } from '@services/http/user.service';
import { UserSettingsService } from '@services/http/userSettings.service';
import { UtilsService } from '@services/Logic/utils.service';
import { UserActionService } from '@services/http/userAction.service';
import { VerticalService } from '@services/http/verticals.service';

export function setupTranslateFactory(
  service: TranslateService,
  storage: StorageService,
) {
  return async () => {
    if (storage.lang?.value) {
      await service.use(storage.lang.value);
    } else {
      await service.use('dk');
    }
  };
}

export const services = [
  {
    provide: APP_INITIALIZER,
    useFactory: setupTranslateFactory,
    deps: [TranslateService, StorageService],
    multi: true,
  },
  AppService,
  AiPriceBudgetSuggesterService,
  AuthService,
  AuthGuard,
  AuthSuccessGuardRedirect,
  BrowsingDatapointsService,
  CategoryTipsSuggestionDescService,
  CityService,
  CommentService,
  ConfettiService,
  ConversationService,
  DataEnrichmentService,
  DueDateNegotiationService,
  EventService,
  FaqService,
  HistoryChangesService,
  MediaService,
  MiscService,
  NavigationService,
  NotificationService,
  NotificationSettingsService,
  PaymentService,
  PriceGuideService,
  SociallogService,
  ReviewService,
  StateService,
  SupportService,
  PreventLoginGuard,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorService,
    multi: true,
  },
  LocationService,
  MessageService,
  OfferService,
  OfferCommentService,
  SocketService,
  TaskService,
  StorageService,
  RandomImageService,
  UserService,
  ReportService,
  TranslateService,
  UtilsService,
  UserSettingsService,
  TagService,
  VerticalService,
  HowToService,
  OfferRequestService,
  TimeHelperService,
  RegionService,
  RehireRequestService,
  PaymentHelperService,
  StaticDataService,
  StoredCreditService,
  UserActionService,
  TierPauseService,
  ReferralService,
  ConflictCaseService,
  BrowserPushNotificationService,
  CompanyService,
];
